"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get // tod: tobe fixed
    // extend(customParseFormat);
    default () {
        return conditionV2;
    },
    get extractLinkRelFiltersAndApply () {
        return extractLinkRelFiltersAndApply;
    }
});
const _util = require("util");
const _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
const _timezone = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/timezone"));
const _utc = /*#__PURE__*/ _interop_require_default(require("dayjs/plugin/utc.js"));
const _nocodbsdk = require("nocodb-sdk");
const _fieldhandler = require("./field-handler");
const _models = require("~/models");
const _pg = require("~/db/aggregations/pg");
const _sqlite3 = require("~/db/aggregations/sqlite3");
const _generateLookupSelectQuery = /*#__PURE__*/ _interop_require_default(require("~/db/generateLookupSelectQuery"));
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _dbHelpers = require("~/helpers/dbHelpers");
const _sqlSanitize = require("~/helpers/sqlSanitize");
const _Filter = /*#__PURE__*/ _interop_require_default(require("~/models/Filter"));
const _utils = require("~/utils");
const _tsUtils = require("~/utils/tsUtils");
const _conditionHelpers = require("~/helpers/conditionHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
_dayjs.default.extend(_utc.default);
_dayjs.default.extend(_timezone.default);
async function conditionV2(baseModelSqlv2, conditionObj, qb, alias, throwErrorIfInvalid = false) {
    if (!conditionObj || typeof conditionObj !== 'object') {
        return;
    }
    await _fieldhandler.FieldHandler.fromBaseModel(baseModelSqlv2).verifyFilters(Array.isArray(conditionObj) ? conditionObj : [
        conditionObj
    ]);
    const filterOperationResult = await parseConditionV2(baseModelSqlv2, conditionObj, {
        count: 0
    }, alias, undefined, throwErrorIfInvalid);
    filterOperationResult.clause(qb);
    filterOperationResult.rootApply == null ? void 0 : filterOperationResult.rootApply.call(filterOperationResult, qb);
}
function getLogicalOpMethod(filter) {
    var _filter_logical_op;
    switch((_filter_logical_op = filter.logical_op) == null ? void 0 : _filter_logical_op.toLowerCase()){
        case 'or':
            return 'orWhere';
        case 'and':
            return 'andWhere';
        case 'not':
            return 'whereNot';
        default:
            return 'where';
    }
}
const parseConditionV2 = async (baseModelSqlv2, _filter, aliasCount = {
    count: 0
}, alias, customWhereClause, throwErrorIfInvalid = false)=>{
    const knex = baseModelSqlv2.dbDriver;
    const context = baseModelSqlv2.context;
    let filter;
    if (!Array.isArray(_filter)) {
        if (!(_filter instanceof _Filter.default)) filter = new _Filter.default(_filter);
        else filter = _filter;
    }
    const supportToggle = await _Filter.default.supportToggle(baseModelSqlv2.context);
    if (Array.isArray(_filter)) {
        // Filter out disabled filters before processing
        const enabledFilters = supportToggle ? _filter.filter((f)=>f.enabled !== false && f.enabled !== 0) : _filter;
        const qbs = await Promise.all(enabledFilters.map((child)=>parseConditionV2(baseModelSqlv2, child, aliasCount, alias, undefined, throwErrorIfInvalid)));
        return {
            rootApply: (qbP)=>{
                for (const qb1 of qbs){
                    qb1.rootApply == null ? void 0 : qb1.rootApply.call(qb1, qbP);
                }
            },
            clause: (qbP)=>{
                qbP.where((qb)=>{
                    for (const [i, qb1] of Object.entries(qbs)){
                        qb[getLogicalOpMethod(enabledFilters[i])](qb1.clause);
                    }
                });
            }
        };
    } else if (filter.is_group) {
        // Skip disabled filter groups entirely (cascade disable)
        if (supportToggle && (filter.enabled === false || filter.enabled === 0)) {
            return {
                clause: ()=>{},
                rootApply: ()=>{}
            };
        }
        const children = await filter.getChildren(context);
        const qbs = await Promise.all((children || []).map((child)=>parseConditionV2(baseModelSqlv2, child, aliasCount, undefined, undefined, throwErrorIfInvalid)));
        return {
            rootApply: (qbP)=>{
                for (const qb1 of qbs){
                    var _qb1_rootApply;
                    qb1 == null ? void 0 : (_qb1_rootApply = qb1.rootApply) == null ? void 0 : _qb1_rootApply.call(qb1, qbP);
                }
            },
            clause: (qbP)=>{
                qbP[getLogicalOpMethod(filter)]((qb)=>{
                    for (const [i, qb1] of Object.entries(qbs)){
                        if (qb1) {
                            qb[getLogicalOpMethod(children[i])](qb1.clause);
                        }
                    }
                });
            }
        };
    } else {
        if (!filter.fk_column_id) return;
        // Skip disabled leaf filters
        if (supportToggle && (filter.enabled === false || filter.enabled === 0)) {
            return {
                clause: ()=>{},
                rootApply: ()=>{}
            };
        }
        // handle group by filter separately,
        // `gb_eq` is equivalent to `eq` but for lookup it compares on aggregated value returns in group by api
        // aggregated value will be either json array or `___` separated string
        // `gb_null` is equivalent to `blank` but for lookup it compares on aggregated value is null
        if (filter.comparison_op === 'gb_eq' || filter.comparison_op === 'gb_null') {
            filter.groupby = true;
            const column = await (0, _helpers.getRefColumnIfAlias)(context, await filter.getColumn(context));
            if (column.uidt === _nocodbsdk.UITypes.Lookup || column.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord) {
                const model = await column.getModel(context);
                const lkQb = await (0, _generateLookupSelectQuery.default)({
                    baseModelSqlv2,
                    alias: alias,
                    model,
                    column,
                    getAlias: (0, _utils.getAliasGenerator)('__gb_filter_lk')
                });
                return {
                    rootApply: undefined,
                    clause: (qb)=>{
                        if (filter.comparison_op === 'gb_eq') qb.where(knex.raw('?', [
                            filter.value
                        ]), lkQb.builder);
                        else qb.whereNull(knex.raw(lkQb.builder).wrap('(', ')'));
                    }
                };
            } else {
                filter.comparison_op = filter.comparison_op === 'gb_eq' ? 'eq' : 'blank';
                // if qrCode or Barcode replace it with value column
                if ([
                    _nocodbsdk.UITypes.QrCode,
                    _nocodbsdk.UITypes.Barcode
                ].includes(column.uidt)) filter.fk_column_id = await column.getColOptions(context).then((col)=>col.fk_column_id);
            }
        }
        if (!filter.fk_column_id) {
            return;
        }
        const filterColumn = await filter.getColumn(context);
        if (!filterColumn) {
            if (throwErrorIfInvalid) {
                _catchError.NcError.get(context).fieldNotFound(filter.fk_column_id);
            }
        }
        const column = await (0, _helpers.getRefColumnIfAlias)(context, filterColumn);
        if (!column) {
            if (throwErrorIfInvalid) {
                _catchError.NcError.get(context).fieldNotFound(filter.fk_column_id);
            }
        }
        if ([
            _nocodbsdk.UITypes.JSON,
            _nocodbsdk.UITypes.LinkToAnotherRecord,
            _nocodbsdk.UITypes.Lookup,
            _nocodbsdk.UITypes.Decimal,
            _nocodbsdk.UITypes.Number,
            _nocodbsdk.UITypes.Rating,
            _nocodbsdk.UITypes.Percent,
            _nocodbsdk.UITypes.User,
            _nocodbsdk.UITypes.DateTime,
            _nocodbsdk.UITypes.Date,
            _nocodbsdk.UITypes.CreatedTime,
            _nocodbsdk.UITypes.LastModifiedTime,
            _nocodbsdk.UITypes.UUID
        ].includes(column.uidt) || [
            _nocodbsdk.UITypes.Rollup,
            _nocodbsdk.UITypes.Formula,
            _nocodbsdk.UITypes.Links
        ].includes(column.uidt) && !customWhereClause) {
            return _fieldhandler.FieldHandler.fromBaseModel(baseModelSqlv2).applyFilter(filter, column, {
                alias,
                conditionParser: parseConditionV2,
                depth: aliasCount,
                context,
                throwErrorIfInvalid,
                customWhereClause
            });
        }
        if ([
            _nocodbsdk.UITypes.Formula
        ].includes(column.uidt) && customWhereClause && [
            _nocodbsdk.UITypes.DateTime,
            _nocodbsdk.UITypes.Date
        ].includes((0, _nocodbsdk.getEquivalentUIType)({
            formulaColumn: column
        }))) {
            return _fieldhandler.FieldHandler.fromBaseModel(baseModelSqlv2).applyFilter(filter, new _models.Column(_extends({}, column, {
                uidt: (0, _nocodbsdk.getEquivalentUIType)({
                    formulaColumn: column
                })
            })), {
                alias,
                conditionParser: parseConditionV2,
                depth: aliasCount,
                context,
                throwErrorIfInvalid,
                customWhereClause
            });
        }
        if ([
            _nocodbsdk.UITypes.User,
            _nocodbsdk.UITypes.CreatedBy,
            _nocodbsdk.UITypes.LastModifiedBy
        ].includes(column.uidt) && [
            'like',
            'nlike'
        ].includes(filter.comparison_op)) {
            // get column name for CreatedBy, LastModifiedBy
            column.column_name = await (0, _dbHelpers.getColumnName)(context, column);
            const baseUsers = await _models.BaseUser.getUsersList(context, {
                base_id: column.base_id,
                include_internal_user: true
            });
            return {
                rootApply: undefined,
                clause: (qb)=>{
                    const users = baseUsers.filter((user)=>{
                        const filterVal = filter.value.toLowerCase();
                        if (filterVal.startsWith('%') && filterVal.endsWith('%')) {
                            return (user.display_name || user.email).toLowerCase().includes(filterVal.substring(1, filterVal.length - 1));
                        } else if (filterVal.startsWith('%')) {
                            return (user.display_name || user.email).toLowerCase().endsWith(filterVal.substring(1));
                        } else if (filterVal.endsWith('%')) {
                            return (user.display_name || user.email).toLowerCase().startsWith(filterVal.substring(0, filterVal.length - 1));
                        }
                        return (user.display_name || user.email).toLowerCase().includes(filterVal.toLowerCase());
                    });
                    let finalStatement = '';
                    // create nested replace statement for each user
                    if (knex.clientType() === 'pg') {
                        finalStatement = `(${(0, _pg.replaceDelimitedWithKeyValuePg)({
                            knex,
                            needleColumn: column.column_name,
                            stack: users.map((user)=>({
                                    key: user.id,
                                    value: user.display_name || user.email
                                }))
                        })})`;
                    } else if (knex.clientType() === 'sqlite3') {
                        finalStatement = `(${(0, _sqlite3.replaceDelimitedWithKeyValueSqlite3)({
                            knex,
                            needleColumn: column.column_name,
                            stack: users.map((user)=>({
                                    key: user.id,
                                    value: user.display_name || user.email
                                }))
                        })})`;
                    } else {
                        finalStatement = users.reduce((acc, user)=>{
                            const qb = knex.raw(`REPLACE(${acc}, ?, ?)`, [
                                user.id,
                                user.display_name || user.email
                            ]);
                            return qb.toQuery();
                        }, knex.raw(`??`, [
                            column.column_name
                        ]).toQuery());
                    }
                    let val = filter.value;
                    if (filter.comparison_op === 'like') {
                        val = (val + '').startsWith('%') || (val + '').endsWith('%') ? val : `%${val}%`;
                        if (knex.clientType() === 'pg') {
                            qb = qb.where(knex.raw(`(${finalStatement}) ilike ?`, [
                                val
                            ]));
                        } else {
                            qb = qb.where(knex.raw(`(${finalStatement}) like ?`, [
                                val
                            ]));
                        }
                    } else {
                        if (!val) {
                            // val is empty -> all values including NULL but empty strings
                            qb.whereNot(column.column_name, '');
                            qb.orWhereNull(column.column_name);
                        } else {
                            val = val.startsWith('%') || val.endsWith('%') ? val : `%${val}%`;
                            qb.where((nestedQb)=>{
                                if (knex.clientType() === 'pg') {
                                    nestedQb.whereNot(knex.raw(`(${finalStatement}) ilike ?`, [
                                        val
                                    ]));
                                } else {
                                    nestedQb.whereNot(knex.raw(`(${finalStatement}) like ?`, [
                                        val
                                    ]));
                                }
                                if (val !== '%%') {
                                    // if value is not empty, empty or null should be included
                                    nestedQb.orWhere(column.column_name, '');
                                    nestedQb.orWhereNull(column.column_name);
                                } else {
                                    // if value is empty, then only null is included
                                    nestedQb.orWhereNull(column.column_name);
                                }
                            });
                        }
                    }
                }
            };
        } else {
            if (filter.comparison_op === 'empty' || filter.comparison_op === 'notempty') filter.value = '';
            let _field = (0, _sqlSanitize.sanitize)(customWhereClause ? filter.value : alias ? `${alias}.${column.column_name}` : column.column_name);
            let _val = customWhereClause ? customWhereClause : filter.value;
            (0, _conditionHelpers.handleCurrentUserFilter)(context, {
                column,
                filter,
                setVal: (val)=>{
                    if (customWhereClause) {
                        _field = val;
                    } else {
                        _val = val;
                    }
                }
            });
            // get column name for CreateTime, LastModifiedTime
            column.column_name = await (0, _dbHelpers.getColumnName)(context, column);
            return {
                rootApply: undefined,
                clause: (qb)=>{
                    let [field, val] = [
                        _field,
                        _val
                    ];
                    // based on custom where clause(builder), we need to change the field and val
                    // todo: refactor this to use a better approach to make it more readable and clean
                    let genVal = customWhereClause ? field : val;
                    const dateFormat = 'YYYY-MM-DD';
                    if ((0, _nocodbsdk.isAIPromptCol)(column)) {
                        if (knex.clientType() === 'pg') {
                            field = knex.raw(`TRIM('"' FROM (??::jsonb->>'value'))`, [
                                column.column_name
                            ]);
                        } else if (knex.clientType().startsWith('mysql')) {
                            field = knex.raw(`JSON_UNQUOTE(JSON_EXTRACT(??, '$.value'))`, [
                                column.column_name
                            ]);
                        } else if (knex.clientType() === 'sqlite3') {
                            field = knex.raw(`json_extract(??, '$.value')`, [
                                column.column_name
                            ]);
                        }
                    }
                    if (column.uidt === _nocodbsdk.UITypes.Formula && (0, _nocodbsdk.getEquivalentUIType)({
                        formulaColumn: column
                    }) == _nocodbsdk.UITypes.DateTime || [
                        _nocodbsdk.UITypes.Date,
                        _nocodbsdk.UITypes.DateTime,
                        _nocodbsdk.UITypes.CreatedTime,
                        _nocodbsdk.UITypes.LastModifiedTime
                    ].includes(column.uidt)) {
                        // should not be called anymore
                        const legacyDateFilter = (0, _util.deprecate)(()=>{
                            var _column_meta;
                            let now = (0, _dayjs.default)(new Date()).utc();
                            const dateFormatFromMeta = column == null ? void 0 : (_column_meta = column.meta) == null ? void 0 : _column_meta.date_format;
                            if (dateFormatFromMeta && (0, _nocodbsdk.isDateMonthFormat)(dateFormatFromMeta)) {
                                // reset to 1st
                                now = (0, _dayjs.default)(now).date(1);
                                if (val) genVal = (0, _dayjs.default)(val).date(1);
                            }
                            // handle sub operation
                            switch(filter.comparison_sub_op){
                                case 'today':
                                    genVal = now;
                                    break;
                                case 'tomorrow':
                                    genVal = now.add(1, 'day');
                                    break;
                                case 'yesterday':
                                    genVal = now.add(-1, 'day');
                                    break;
                                case 'oneWeekAgo':
                                    genVal = now.add(-1, 'week');
                                    break;
                                case 'oneWeekFromNow':
                                    genVal = now.add(1, 'week');
                                    break;
                                case 'oneMonthAgo':
                                    genVal = now.add(-1, 'month');
                                    break;
                                case 'oneMonthFromNow':
                                    genVal = now.add(1, 'month');
                                    break;
                                case 'daysAgo':
                                    if (!val) return;
                                    genVal = now.add(-genVal, 'day');
                                    break;
                                case 'daysFromNow':
                                    if (!val) return;
                                    genVal = now.add(genVal, 'day');
                                    break;
                                case 'exactDate':
                                    if (!genVal) return;
                                    break;
                                // sub-ops for `isWithin` comparison
                                case 'pastWeek':
                                    genVal = now.add(-1, 'week');
                                    break;
                                case 'pastMonth':
                                    genVal = now.add(-1, 'month');
                                    break;
                                case 'pastYear':
                                    genVal = now.add(-1, 'year');
                                    break;
                                case 'nextWeek':
                                    genVal = now.add(1, 'week');
                                    break;
                                case 'nextMonth':
                                    genVal = now.add(1, 'month');
                                    break;
                                case 'nextYear':
                                    genVal = now.add(1, 'year');
                                    break;
                                case 'pastNumberOfDays':
                                    if (!val) return;
                                    genVal = now.add(-genVal, 'day');
                                    break;
                                case 'nextNumberOfDays':
                                    if (!genVal) return;
                                    genVal = now.add(genVal, 'day');
                                    break;
                            }
                            if (_dayjs.default.isDayjs(genVal)) {
                                // turn `val` in dayjs object format to string
                                genVal = genVal.format(dateFormat).toString();
                                // keep YYYY-MM-DD only for date
                                genVal = column.uidt === _nocodbsdk.UITypes.Date ? genVal.substring(0, 10) : genVal;
                            }
                        }, `legacy date filter is deprecated, should not be called, stack: ${new Error().stack}`);
                        legacyDateFilter();
                    }
                    if ((0, _nocodbsdk.isNumericCol)(column.uidt) && typeof genVal === 'string' && !isNaN(+genVal)) {
                        // convert to number
                        genVal = +genVal;
                    }
                    // if customWhereClause(builder) is provided, replace field with raw value
                    // or assign value to val
                    if (customWhereClause) {
                        field = knex.raw('?', [
                            genVal
                        ]);
                    } else {
                        val = genVal;
                    }
                    switch(filter.comparison_op){
                        case 'eq':
                            if (column.uidt === _nocodbsdk.UITypes.JSON) {
                                if (val === '') {
                                    // For JSON, "eq" with empty string matches '{}' or '[]' or null
                                    if (knex.clientType() === 'pg') {
                                        qb = qb.where((nestedQb)=>{
                                            nestedQb.where(knex.raw("??::jsonb = '{}'::jsonb", [
                                                field
                                            ])).orWhere(knex.raw("??::jsonb = '[]'::jsonb", [
                                                field
                                            ])).orWhereNull(field);
                                        });
                                    } else {
                                        qb = qb.where((nestedQb)=>{
                                            nestedQb.where(field, '{}').orWhere(field, '[]').orWhereNull(field);
                                        });
                                    }
                                } else {
                                    const { jsonVal, isValidJson } = (0, _tsUtils.validateAndStringifyJson)(val);
                                    if (knex.clientType() === 'pg') {
                                        qb = qb.where((nestedQb)=>{
                                            if (isValidJson) {
                                                // Valid JSON case: use JSONB comparison
                                                nestedQb.where(knex.raw('??::jsonb = ?::jsonb', [
                                                    field,
                                                    jsonVal
                                                ]));
                                            } else {
                                                // Invalid JSON case: fall back to text comparison
                                                nestedQb.where(knex.raw('??::text = ?', [
                                                    field,
                                                    jsonVal
                                                ]));
                                            }
                                        });
                                    } else {
                                        qb = qb.where((nestedQb)=>{
                                            nestedQb.where(field, jsonVal);
                                        });
                                    }
                                }
                            } else {
                                if (knex.clientType() === 'mysql2' || knex.clientType() === 'mysql') {
                                    if ([
                                        _nocodbsdk.UITypes.Duration,
                                        _nocodbsdk.UITypes.Currency,
                                        _nocodbsdk.UITypes.Percent,
                                        _nocodbsdk.UITypes.Number,
                                        _nocodbsdk.UITypes.Decimal,
                                        _nocodbsdk.UITypes.Rating,
                                        _nocodbsdk.UITypes.Rollup,
                                        _nocodbsdk.UITypes.Links
                                    ].includes(column.uidt)) {
                                        qb = qb.where(field, val);
                                    } else if (column.uidt === _nocodbsdk.UITypes.Formula && (0, _nocodbsdk.getEquivalentUIType)({
                                        formulaColumn: column
                                    }) == _nocodbsdk.UITypes.DateTime || column.ct === 'timestamp' || column.ct === 'date' || column.ct === 'datetime') {
                                        // ignore seconds part in datetime and filter when using it for group by
                                        if (filter.groupby && column.ct !== 'date') {
                                            const valWithoutTz = val.replace(/[+-]\d+:\d+$/, '');
                                            qb = qb.where(knex.raw("CONVERT_TZ(DATE_SUB(??, INTERVAL SECOND(??) SECOND), @@GLOBAL.time_zone, '+00:00') = DATE_SUB(?, INTERVAL SECOND(?) SECOND)", [
                                                field,
                                                field,
                                                valWithoutTz,
                                                valWithoutTz
                                            ]));
                                        } else qb = qb.where(knex.raw('DATE(??) = DATE(?)', [
                                            field,
                                            val
                                        ]));
                                    } else {
                                        // mysql is case-insensitive for strings, turn to case-sensitive
                                        qb = qb.where(knex.raw('BINARY ?? = ?', [
                                            field,
                                            val
                                        ]));
                                    }
                                } else {
                                    if (column.uidt === _nocodbsdk.UITypes.Formula && (0, _nocodbsdk.getEquivalentUIType)({
                                        formulaColumn: column
                                    }) == _nocodbsdk.UITypes.DateTime || [
                                        _nocodbsdk.UITypes.DateTime,
                                        _nocodbsdk.UITypes.CreatedTime,
                                        _nocodbsdk.UITypes.LastModifiedTime
                                    ].includes(column.uidt)) {
                                        if (qb.client.config.client === 'pg') {
                                            // ignore seconds part in datetime and filter when using it for group by
                                            if (filter.groupby) qb = qb.where(knex.raw("date_trunc('minute', ??) + interval '0 seconds' = ?", [
                                                field,
                                                val
                                            ]));
                                            else qb = qb.where(knex.raw('??::date = ?', [
                                                field,
                                                val
                                            ]));
                                        } else {
                                            // ignore seconds part in datetime and filter when using it for group by
                                            if (filter.groupby) {
                                                if (knex.clientType() === 'sqlite3') qb = qb.where(knex.raw(`Datetime(strftime ('%Y-%m-%d %H:%M:00',:column:) ||
  (
   CASE WHEN substr(:column:, 20, 1) = '+' THEN
    printf ('+%s:',
     substr(:column:, 21, 2)) || printf ('%s',
     substr(:column:, 24, 2))
   WHEN substr(:column:, 20, 1) = '-' THEN
    printf ('-%s:',
     substr(:column:, 21, 2)) || printf ('%s',
     substr(:column:, 24, 2))
   ELSE
    '+00:00'
   END)) = Datetime(:val)`, {
                                                    column: field,
                                                    val
                                                }));
                                                else qb = qb.where(knex.raw('?? = ?', [
                                                    field,
                                                    val
                                                ]));
                                            } else qb = qb.where(knex.raw('DATE(??) = DATE(?)', [
                                                field,
                                                val
                                            ]));
                                        }
                                    } else {
                                        qb = qb.where(field, val);
                                    }
                                }
                                if (column.uidt === _nocodbsdk.UITypes.Rating && val === 0) {
                                    // unset rating is considered as NULL
                                    qb = qb.orWhereNull(field);
                                }
                            }
                            break;
                        case 'neq':
                        case 'not':
                            if (column.uidt === _nocodbsdk.UITypes.JSON) {
                                if (val === '') {
                                    if (knex.clientType() === 'pg') {
                                        qb = qb.where((nestedQb)=>{
                                            nestedQb.whereNot(knex.raw("??::jsonb = '{}'::jsonb", [
                                                field
                                            ])).whereNot(knex.raw("??::jsonb = '[]'::jsonb", [
                                                field
                                            ]));
                                            nestedQb.orWhereNull(field);
                                        });
                                    } else if (knex.clientType().startsWith('mysql') || knex.clientType() === 'sqlite3') {
                                        qb = qb.where((nestedQb)=>{
                                            nestedQb.whereNot(field, '{}').whereNot(field, '[]');
                                            nestedQb.orWhereNull(field);
                                        });
                                    } else {
                                        qb = qb.whereNotNull(field).orWhereNull(field);
                                    }
                                } else {
                                    const { jsonVal, isValidJson } = (0, _tsUtils.validateAndStringifyJson)(val);
                                    if (knex.clientType() === 'pg') {
                                        qb = qb.where((nestedQb)=>{
                                            if (isValidJson) {
                                                // Valid JSON case: use JSONB comparison
                                                nestedQb.where(knex.raw('??::jsonb != ?::jsonb', [
                                                    field,
                                                    jsonVal
                                                ]));
                                                nestedQb.orWhereNull(field);
                                            } else {
                                                // Invalid JSON case: fall back to text comparison
                                                nestedQb.where(knex.raw('??::text != ?', [
                                                    field,
                                                    jsonVal
                                                ])).orWhereNull(field);
                                            }
                                        });
                                    } else {
                                        qb = qb.where((nestedQb)=>{
                                            nestedQb.whereNot(field, jsonVal);
                                            nestedQb.orWhereNull(field);
                                        });
                                    }
                                }
                            } else if (knex.clientType() === 'mysql2') {
                                if ([
                                    _nocodbsdk.UITypes.Duration,
                                    _nocodbsdk.UITypes.Currency,
                                    _nocodbsdk.UITypes.Percent,
                                    _nocodbsdk.UITypes.Number,
                                    _nocodbsdk.UITypes.Decimal,
                                    _nocodbsdk.UITypes.Rollup,
                                    _nocodbsdk.UITypes.Links
                                ].includes(column.uidt)) {
                                    qb = qb.where((nestedQb)=>{
                                        nestedQb.whereNot(field, val);
                                        if (column.uidt !== _nocodbsdk.UITypes.Links) nestedQb.orWhereNull(customWhereClause ? _val : _field);
                                    });
                                } else if (column.uidt === _nocodbsdk.UITypes.Rating) {
                                    if (val === 0) {
                                        qb = qb.whereNot(field, val).whereNotNull(field);
                                    } else {
                                        qb = qb.whereNot(field, val).orWhereNull(field);
                                    }
                                } else {
                                    qb = qb.where((nestedQb)=>{
                                        nestedQb.where(knex.raw('BINARY ?? != ?', [
                                            field,
                                            val
                                        ]));
                                        if (column.uidt !== _nocodbsdk.UITypes.Rating) {
                                            nestedQb.orWhereNull(customWhereClause ? _val : _field);
                                        }
                                    });
                                }
                            } else {
                                qb = qb.where((nestedQb)=>{
                                    nestedQb.whereNot(field, val);
                                    if (column.uidt !== _nocodbsdk.UITypes.Links) nestedQb.orWhereNull(customWhereClause ? _val : _field);
                                });
                            }
                            break;
                        case 'like':
                            if (!val) {
                                if (column.uidt === _nocodbsdk.UITypes.Attachment) {
                                    qb = qb.orWhereNull(field).orWhere(field, '[]').orWhere(field, 'null');
                                } else if (column.uidt === _nocodbsdk.UITypes.JSON) {
                                    // For JSON, empty "like" means all non-null values
                                    qb = qb.whereNotNull(field);
                                } else {
                                    // val is empty -> all values including empty strings but NULL
                                    qb.where(field, '');
                                    qb.orWhereNotNull(field);
                                }
                            } else {
                                if (column.uidt === _nocodbsdk.UITypes.Formula) {
                                    [field, val] = [
                                        val,
                                        field
                                    ];
                                    val = `%${val}%`.replace(/^%'([\s\S]*)'%$/, '%$1%');
                                } else {
                                    val = (val + '').startsWith('%') || (val + '').endsWith('%') ? val : `%${val}%`;
                                }
                                if (knex.clientType() === 'pg') {
                                    qb = qb.where(knex.raw('??::text ilike ?', [
                                        field,
                                        val
                                    ]));
                                } else {
                                    qb = qb.where(field, 'like', val);
                                }
                            }
                            break;
                        case 'nlike':
                            if (!val) {
                                if (column.uidt === _nocodbsdk.UITypes.Attachment) {
                                    qb.whereNot(field, '').whereNot(field, 'null').whereNot(field, '[]');
                                } else if (column.uidt === _nocodbsdk.UITypes.JSON) {
                                    // For JSON, empty "nlike" means only NULL values
                                    qb = qb.whereNull(field);
                                } else {
                                    // val is empty -> all values including NULL but empty strings
                                    qb.whereNot(field, '');
                                    qb.orWhereNull(field);
                                }
                            } else {
                                if (column.uidt === _nocodbsdk.UITypes.Formula) {
                                    [field, val] = [
                                        val,
                                        field
                                    ];
                                    val = `%${val}%`.replace(/^%'([\s\S]*)'%$/, '%$1%');
                                } else {
                                    val = val.startsWith('%') || val.endsWith('%') ? val : `%${val}%`;
                                }
                                if (column.uidt === _nocodbsdk.UITypes.JSON) {
                                    if (knex.clientType() === 'pg') {
                                        // Casting to jsonb ensures it’s in the binary format before converting to text.
                                        // This avoids issues with json preserving whitespace or formatting that might affect the NOT ILIKE comparison.
                                        qb = qb.where(knex.raw('??::jsonb::text NOT ILIKE ?', [
                                            field,
                                            val
                                        ]));
                                    } else {
                                        qb = qb.whereNot(field, 'like', val);
                                    }
                                } else {
                                    qb.where((nestedQb)=>{
                                        if (knex.clientType() === 'pg') {
                                            nestedQb.where(knex.raw('??::text not ilike ?', [
                                                field,
                                                val
                                            ]));
                                        } else {
                                            nestedQb.whereNot(field, 'like', val);
                                        }
                                        if (val !== '%%') {
                                            // if value is not empty, empty or null should be included
                                            nestedQb.orWhere(field, '');
                                            nestedQb.orWhereNull(field);
                                        } else {
                                            // if value is empty, then only null is included
                                            nestedQb.orWhereNull(field);
                                        }
                                    });
                                }
                            }
                            break;
                        case 'allof':
                        case 'anyof':
                        case 'nallof':
                        case 'nanyof':
                            {
                                // Condition for filter, without negation
                                const condition = (builder)=>{
                                    var _ref;
                                    var _column_dt;
                                    let items = (_ref = val == null ? void 0 : val.split(',')) != null ? _ref : [];
                                    // remove trailing space if database is MySQL and datatype is enum/set
                                    if ([
                                        'mysql2',
                                        'mysql'
                                    ].includes(knex.clientType()) && [
                                        'enum',
                                        'set'
                                    ].includes((_column_dt = column.dt) == null ? void 0 : _column_dt.toLowerCase())) {
                                        items = items.map((item)=>item.trimEnd());
                                    }
                                    for(let i = 0; i < (items == null ? void 0 : items.length); i++){
                                        let sql;
                                        const bindings = [
                                            field,
                                            `%,${items[i]},%`,
                                            field,
                                            `%, ${items[i]},%`
                                        ];
                                        if (knex.clientType() === 'pg') {
                                            sql = "((',' || ??::text || ',') ilike ? OR (',' || ??::text || ',') ilike ?)";
                                        } else if (knex.clientType() === 'sqlite3') {
                                            sql = "((',' || ?? || ',') like ? OR (',' || ?? || ',') like ?)";
                                        } else {
                                            sql = "(CONCAT(',', ??, ',') like ? OR CONCAT(',', ??, ',') like ?)";
                                        }
                                        if (i === 0) {
                                            builder = builder.where(knex.raw(sql, bindings));
                                        } else {
                                            if (filter.comparison_op === 'allof' || filter.comparison_op === 'nallof') {
                                                builder = builder.andWhere(knex.raw(sql, bindings));
                                            } else {
                                                builder = builder.orWhere(knex.raw(sql, bindings));
                                            }
                                        }
                                    }
                                };
                                if (filter.comparison_op === 'allof' || filter.comparison_op === 'anyof') {
                                    qb = qb.where(condition);
                                } else {
                                    qb = qb.whereNot(condition).orWhereNull(field);
                                }
                            }
                            break;
                        case 'gt':
                            {
                                const gt_op = customWhereClause ? '<' : '>';
                                // If the column is a datetime and the client is pg and the value has a timezone offset at the end
                                // then we need to convert the value to timestamptz before comparing
                                if ((column.uidt === _nocodbsdk.UITypes.DateTime || column.uidt === _nocodbsdk.UITypes.Date || column.uidt === _nocodbsdk.UITypes.CreatedTime || column.uidt === _nocodbsdk.UITypes.LastModifiedTime) && val.match(/[+-]\d{2}:\d{2}$/)) {
                                    if (qb.client.config.client === 'pg') {
                                        if (column.dt !== 'timestamp with time zone' && column.dt !== 'timestamptz') {
                                            qb.where(knex.raw("?? AT TIME ZONE CURRENT_SETTING('timezone') AT TIME ZONE 'UTC'", [
                                                field
                                            ]), gt_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        } else {
                                            qb.where(field, gt_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        }
                                    } else if (qb.client.config.client === 'sqlite3') {
                                        qb.where(field, gt_op, knex.raw('datetime(?)', [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else if (qb.client.config.client === 'mysql2') {
                                        qb.where(field, gt_op, knex.raw(`CONVERT_TZ(?, '+00:00', @@GLOBAL.time_zone)`, [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else {
                                        qb.where(field, gt_op, val);
                                    }
                                } else {
                                    qb = qb.where(field, gt_op, val);
                                    if (column.uidt === _nocodbsdk.UITypes.Rating) {
                                        // unset rating is considered as NULL
                                        if (gt_op === '<' && val > 0) {
                                            qb = qb.orWhereNull(field);
                                        }
                                    }
                                }
                            }
                            break;
                        case 'ge':
                        case 'gte':
                            {
                                const ge_op = customWhereClause ? '<=' : '>=';
                                // If the column is a datetime and the client is pg and the value has a timezone offset at the end
                                // then we need to convert the value to timestamptz before comparing
                                if ((column.uidt === _nocodbsdk.UITypes.DateTime || column.uidt === _nocodbsdk.UITypes.Date || column.uidt === _nocodbsdk.UITypes.CreatedTime || column.uidt === _nocodbsdk.UITypes.LastModifiedTime) && val.match(/[+-]\d{2}:\d{2}$/)) {
                                    if (qb.client.config.client === 'pg') {
                                        if (column.dt !== 'timestamp with time zone' && column.dt !== 'timestamptz') {
                                            qb.where(knex.raw("?? AT TIME ZONE CURRENT_SETTING('timezone') AT TIME ZONE 'UTC'", [
                                                field
                                            ]), ge_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        } else {
                                            qb.where(field, ge_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        }
                                    } else if (qb.client.config.client === 'sqlite3') {
                                        qb.where(field, ge_op, knex.raw('datetime(?)', [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else if (qb.client.config.client === 'mysql2') {
                                        qb.where(field, ge_op, knex.raw(`CONVERT_TZ(?, '+00:00', @@GLOBAL.time_zone)`, [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else {
                                        qb.where(field, ge_op, val);
                                    }
                                } else {
                                    qb = qb.where(field, ge_op, val);
                                    if (column.uidt === _nocodbsdk.UITypes.Rating) {
                                        // unset rating is considered as NULL
                                        if (ge_op === '<=' || ge_op === '>=' && val === 0) {
                                            qb = qb.orWhereNull(field);
                                        }
                                    }
                                }
                            }
                            break;
                        case 'lt':
                            {
                                const lt_op = customWhereClause ? '>' : '<';
                                // If the column is a datetime and the client is pg and the value has a timezone offset at the end
                                // then we need to convert the value to timestamptz before comparing
                                if ((column.uidt === _nocodbsdk.UITypes.DateTime || column.uidt === _nocodbsdk.UITypes.Date || column.uidt === _nocodbsdk.UITypes.CreatedTime || column.uidt === _nocodbsdk.UITypes.LastModifiedTime) && val.match(/[+-]\d{2}:\d{2}$/)) {
                                    if (qb.client.config.client === 'pg') {
                                        if (column.dt !== 'timestamp with time zone' && column.dt !== 'timestamptz') {
                                            qb.where(knex.raw("?? AT TIME ZONE CURRENT_SETTING('timezone') AT TIME ZONE 'UTC'", [
                                                field
                                            ]), lt_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        } else {
                                            qb.where(field, lt_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        }
                                    } else if (qb.client.config.client === 'sqlite3') {
                                        qb.where(field, lt_op, knex.raw('datetime(?)', [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else if (qb.client.config.client === 'mysql2') {
                                        qb.where(field, lt_op, knex.raw(`CONVERT_TZ(?, '+00:00', @@GLOBAL.time_zone)`, [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else {
                                        qb.where(field, lt_op, val);
                                    }
                                } else {
                                    qb = qb.where(field, lt_op, val);
                                    if (column.uidt === _nocodbsdk.UITypes.Rating) {
                                        // unset number is considered as NULL
                                        if (lt_op === '<' && val > 0) {
                                            qb = qb.orWhereNull(field);
                                        }
                                    }
                                }
                            }
                            break;
                        case 'le':
                        case 'lte':
                            {
                                const le_op = customWhereClause ? '>=' : '<=';
                                // If the column is a datetime and the client is pg and the value has a timezone offset at the end
                                // then we need to convert the value to timestamptz before comparing
                                if ((column.uidt === _nocodbsdk.UITypes.DateTime || column.uidt === _nocodbsdk.UITypes.Date || column.uidt === _nocodbsdk.UITypes.CreatedTime || column.uidt === _nocodbsdk.UITypes.LastModifiedTime) && val.match(/[+-]\d{2}:\d{2}$/)) {
                                    if (qb.client.config.client === 'pg') {
                                        if (column.dt !== 'timestamp with time zone' && column.dt !== 'timestamptz') {
                                            qb.where(knex.raw("?? AT TIME ZONE CURRENT_SETTING('timezone') AT TIME ZONE 'UTC'", [
                                                field
                                            ]), le_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        } else {
                                            qb.where(field, le_op, knex.raw('?::timestamptz', [
                                                val
                                            ]));
                                        }
                                    } else if (qb.client.config.client === 'sqlite3') {
                                        qb.where(field, le_op, knex.raw('datetime(?)', [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else if (qb.client.config.client === 'mysql2') {
                                        qb.where(field, le_op, knex.raw(`CONVERT_TZ(?, '+00:00', @@GLOBAL.time_zone)`, [
                                            (0, _dayjs.default)(val).utc().format('YYYY-MM-DD HH:mm:ss')
                                        ]));
                                    } else {
                                        qb.where(field, le_op, val);
                                    }
                                } else {
                                    qb = qb.where(field, le_op, val);
                                    if (column.uidt === _nocodbsdk.UITypes.Rating) {
                                        // unset number is considered as NULL
                                        if (le_op === '<=' || le_op === '>=' && val === 0) {
                                            qb = qb.orWhereNull(field);
                                        }
                                    }
                                }
                            }
                            break;
                        case 'in':
                            var _val_split;
                            qb = qb.whereIn(field, Array.isArray(val) ? val : val == null ? void 0 : (_val_split = val.split) == null ? void 0 : _val_split.call(val, ','));
                            break;
                        case 'is':
                            if (filter.value === 'null' || filter.value === null) qb = qb.whereNull(customWhereClause || field);
                            else if (filter.value === 'notnull') qb = qb.whereNotNull(customWhereClause || field);
                            else if (filter.value === 'empty') qb = qb.where(customWhereClause || field, '');
                            else if (filter.value === 'notempty') qb = qb.whereNot(customWhereClause || field, '').orWhereNull(field);
                            else if (filter.value === 'true') qb = qb.where(customWhereClause || field, true);
                            else if (filter.value === 'false') qb = qb.where(customWhereClause || field, false);
                            break;
                        case 'isnot':
                            if (filter.value === 'null') qb = qb.whereNotNull(customWhereClause || field);
                            else if (filter.value === 'notnull') qb = qb.whereNull(customWhereClause || field);
                            else if (filter.value === 'empty') qb = qb.whereNot(customWhereClause || field, '');
                            else if (filter.value === 'notempty') qb = qb.where(customWhereClause || field, '');
                            else if (filter.value === 'true') qb = qb.whereNot(customWhereClause || field, true);
                            else if (filter.value === 'false') qb = qb.whereNot(customWhereClause || field, false);
                            break;
                        case 'empty':
                            if (column.uidt === _nocodbsdk.UITypes.Formula) {
                                [field, val] = [
                                    val,
                                    field
                                ];
                            }
                            qb = qb.where(field, val);
                            break;
                        case 'notempty':
                            if (column.uidt === _nocodbsdk.UITypes.Formula) {
                                [field, val] = [
                                    val,
                                    field
                                ];
                            }
                            qb = qb.whereNot(field, val).orWhereNull(field);
                            break;
                        case 'null':
                            qb = qb.whereNull(customWhereClause || field);
                            break;
                        case 'notnull':
                            qb = qb.whereNotNull(customWhereClause || field);
                            break;
                        case 'blank':
                            if (column.uidt === _nocodbsdk.UITypes.Attachment) {
                                qb = qb.whereNull(customWhereClause || field).orWhere(field, '[]').orWhere(field, 'null');
                            } else if (column.uidt === _nocodbsdk.UITypes.JSON) {
                                if (knex.clientType() === 'pg') {
                                    qb = qb.whereNull(field).orWhere(knex.raw("??::jsonb = '{}'::jsonb", [
                                        field
                                    ])).orWhere(knex.raw("??::jsonb = '[]'::jsonb", [
                                        field
                                    ]));
                                } else if (knex.clientType().startsWith('mysql') || knex.clientType() === 'sqlite3') {
                                    qb = qb.whereNull(field).orWhere(field, '{}').orWhere(field, '[]');
                                } else {
                                    qb = qb.whereNull(field);
                                }
                            } else if (column.uidt === _nocodbsdk.UITypes.Formula) {
                                var _column_colOptions_parsed_tree;
                                qb = qb.whereNull(customWhereClause || field);
                                if (((_column_colOptions_parsed_tree = (column == null ? void 0 : column.colOptions).parsed_tree) == null ? void 0 : _column_colOptions_parsed_tree.dataType) === _nocodbsdk.FormulaDataTypes.STRING) {
                                    qb = qb.orWhere(customWhereClause || field, '');
                                }
                            } else {
                                qb = qb.whereNull(customWhereClause || field);
                                if (!(0, _nocodbsdk.isNumericCol)(column.uidt) && ![
                                    _nocodbsdk.UITypes.Date,
                                    _nocodbsdk.UITypes.CreatedTime,
                                    _nocodbsdk.UITypes.LastModifiedTime,
                                    _nocodbsdk.UITypes.DateTime,
                                    _nocodbsdk.UITypes.Time
                                ].includes(column.uidt)) {
                                    qb = qb.orWhere(field, '');
                                }
                            }
                            break;
                        case 'notblank':
                            if (column.uidt === _nocodbsdk.UITypes.Attachment) {
                                qb = qb.whereNotNull(customWhereClause || field).whereNot(field, '[]').whereNot(field, 'null');
                            } else if (column.uidt === _nocodbsdk.UITypes.JSON) {
                                if (knex.clientType() === 'pg') {
                                    qb = qb.whereNotNull(field).whereNot(knex.raw("??::jsonb = '{}'::jsonb", [
                                        field
                                    ])).whereNot(knex.raw("??::jsonb = '[]'::jsonb", [
                                        field
                                    ]));
                                } else if (knex.clientType().startsWith('mysql') || knex.clientType() === 'sqlite3') {
                                    qb = qb.whereNotNull(field).whereNot(field, '{}').whereNot(field, '[]');
                                } else {
                                    qb = qb.whereNotNull(field); // Fallback for other DBs
                                }
                            } else if (column.uidt === _nocodbsdk.UITypes.Formula) {
                                var _column_colOptions_parsed_tree1;
                                qb = qb.whereNotNull(customWhereClause || field);
                                if (((_column_colOptions_parsed_tree1 = (column == null ? void 0 : column.colOptions).parsed_tree) == null ? void 0 : _column_colOptions_parsed_tree1.dataType) === _nocodbsdk.FormulaDataTypes.STRING) {
                                    qb = qb.whereNot(customWhereClause || field, '');
                                }
                            } else {
                                qb = qb.whereNotNull(customWhereClause || field);
                                if (!(0, _nocodbsdk.isNumericCol)(column.uidt) && ![
                                    _nocodbsdk.UITypes.Date,
                                    _nocodbsdk.UITypes.DateTime,
                                    _nocodbsdk.UITypes.CreatedTime,
                                    _nocodbsdk.UITypes.LastModifiedTime,
                                    _nocodbsdk.UITypes.Time
                                ].includes(column.uidt)) {
                                    qb = qb.whereNot(field, '');
                                }
                            }
                            break;
                        case 'checked':
                            qb = qb.where(customWhereClause || field, true);
                            break;
                        case 'notchecked':
                            qb = qb.where((grpdQb)=>{
                                grpdQb.whereNull(customWhereClause || field).orWhere(customWhereClause || field, false);
                            });
                            break;
                        case 'btw':
                            qb = qb.whereBetween(field, val.split(','));
                            break;
                        case 'nbtw':
                            qb = qb.whereNotBetween(field, val.split(','));
                            break;
                        case 'isWithin':
                            {
                                let now = (0, _dayjs.default)(new Date()).utc().format(dateFormat).toString();
                                now = column.uidt === _nocodbsdk.UITypes.Date ? now.substring(0, 10) : now;
                                // switch between arg based on customWhereClause(builder)
                                const [firstArg, rangeArg] = [
                                    customWhereClause ? val : field,
                                    customWhereClause ? field : val
                                ];
                                switch(filter.comparison_sub_op){
                                    case 'pastWeek':
                                    case 'pastMonth':
                                    case 'pastYear':
                                    case 'pastNumberOfDays':
                                        qb = qb.whereBetween(firstArg, [
                                            rangeArg,
                                            now
                                        ]);
                                        break;
                                    case 'nextWeek':
                                    case 'nextMonth':
                                    case 'nextYear':
                                    case 'nextNumberOfDays':
                                        qb = qb.whereBetween(firstArg, [
                                            now,
                                            rangeArg
                                        ]);
                                        break;
                                }
                            }
                    }
                }
            };
        }
    }
};
async function extractLinkRelFiltersAndApply(_) {
// do nothing, it's just a placeholder
}
